import { Injectable } from '@angular/core';
import { Price } from '@kion/data-models';

@Injectable({
  providedIn: 'root'
})
export class ProductPriceService {

  constructor() { }

  getBruttoPrice(price: Price): string {
    if (price.netto) {
      return price.formattedOtherPrice;
    }
    return price.formattedValue;
  }

  getBruttoStrikedPrice(price: Price): string {
    if (price.netto) {
      return price.formattedOtherStrikedPrice;
    }
    return price.formattedStrikedPrice;
  }

  getNettoPrice(price: Price): string {
    if (price.netto) {
      return price.formattedValue;
    }
    return price.formattedOtherPrice;
  }

  getStrikedNettoPrice(price: Price): string {
    if (price.netto) {
      return price.formattedStrikedPrice;
    }
    return price.formattedOtherStrikedPrice;
  }
}
